import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MessageService } from './chat-bot/message.service';
import { SpinnerService } from './_services/spinner.service';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './_services/user.service';
import { MemoryService } from './_services/memory.service';
import { ToastrService } from 'ngx-toastr';
import { TestService } from './_services/test.service';
import { beatBlipSubscriptionConsts } from './consts/beatBlipSubscriptionConsts';
import { User } from './_models/user';
import { DisableRightService } from './_services/disable-right.service';
import { BrowserSessionService } from './browser-session.service';
// import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'BeatBlipSubscription';
  // router: string;
  chatBotEnabled: boolean = environment.chatBotEnable;
  enableSelector: boolean=false;
  headerOptions = {
    showSetting: false,
    showSearch: false,
    heading: "",
    data: undefined,
  };
  projectId: any;
  projectData: any;
  projectService: any;
  agentCheck: boolean = false;
  currentUser: any;
  disableRightClick;
  headerCheck: boolean = false;

  constructor(private _router: Router, private spinner: SpinnerService, private messageService: MessageService, private cookieService: CookieService, private userService: UserService, private memoryService:MemoryService, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private testService: TestService,
    private rightClick: DisableRightService,private _boot: BrowserSessionService) {
     console.log('inside serve1');
     this.disableRightClick = environment.disableRightClick;
  
     _router.events.forEach((event) => {

      if(event instanceof NavigationStart) {
        if(event.url.includes('suite')){
          this.headerOptions.heading='Suite'

        }
      }
      if(this.disableRightClick){
      if(event instanceof NavigationStart) {
        if(!event.url.includes('test')){
            this.rightClick.disableRightClick();
        }
      }
    }
    });

    this._router.events.subscribe((event: any) => {
      console.log(" HEADER CHECK ", event.url);
      if (event instanceof NavigationEnd) {
        // Access the current URL
        let currentUrl = this._router.url;
        this.headerCheck =  currentUrl.includes('login');
        console.log(this.headerCheck + " HEADER CHECK ")
      }
    });


    // send message to parent
    window.top.postMessage(" ", "*");

    // receive message from parent
    window.addEventListener('message', (event) =>{
      if(event.data.type == 'message'){
        this.memoryService.setAgentCheck(true);
        this.agentCheck = true;
        console.log("Message received from the parent: " + event.data);
      }
      else if(event.data.type == 'cred')
      {
        console.log("cred after receiving",event.data);
        let obj = {userName: event.data.value.username, password: event.data.value.password, remember: false };
        let returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];
        console.log("cred before hitting the api", obj);
        this.userService.login(obj).subscribe((data: any) => {
          if (data) {
              // this.loginData = data;
              
              var expireDate = new Date();
              expireDate.setHours(23, 59, 0, 0);
              data.user_name = obj.userName;
              if(this.agentCheck){
                  this.testService.sendTokenData(data)
              }
              else{
                  this.cookieService.set('loginSubscriptionData', JSON.stringify(data), 2345, "/", '', false, 'Lax');
              }
              
              this.getUserDetail();
              const CValue = this.cookieService.get('loginSubscriptionData');
              //   console.log('Cookie Value>>',CValue);
              this.cookieService.delete('loginData', '/BeatBlipUI')//Delete The previous user login data.

              //this.cookieService.set('loginData',JSON.stringify(data),32,'','.localhost:8080');
              var hash = window.location.hash
              var redirect = 'false';
              if (hash) {
                  var params = hash.split('=');
                  if (params.length > 1) {
                      redirect = params[1];
                  }
              }
              if (redirect === 'true') {
                  window.location.href = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port + "/BeatBlipUI"
              }
              else if(returnUrl)
              {
                  this._router.navigate([returnUrl]);
              }
               else {
                  setTimeout(() => {
                      this._router.navigate(['/Dashboard']);
                  }, 500);
                 
              }
      
          }
      }, error => {
          this.toastr.clear();
          if (error.error && error.error.appStatusCode) {
              this.toastr.error(error.error.message);
          }
      });;
      }
    });


    setTimeout(() => {
      this.enableSelector = true;
    }, 100);
  }

  getUserDetail(){
    this.userService.getUser().subscribe((data) => {
        this.currentUser = data;
        if(this.agentCheck)
        {
            this.memoryService.setCurrentUser(data);
            this.memoryService.setSelectedProject(null);
        }
        else
        {
            localStorage.setItem("currentUser", JSON.stringify(data));
            localStorage.removeItem("selectedProject");
        }
      });
}

  @HostListener('window:message', ['$event'])
  onMessage(e)
  {
    console.log('inside serve2', e.data);
    if(window.location.origin == e.origin)
    {
      return;
    }
    console.log('inside serve3', e.data);
    let obj = {userName: e.data.username, password: e.data.password, remember: false };
    const result = this.userService.login(obj)
  }
  private isReload = false;
@HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    // Mark it as reload/navigation
    this.isReload = true;
  }

  @HostListener('window:pagehide', ['$event'])
  onPageHide(event: PageTransitionEvent) {
    // pagehide fires on close *and* reload
    if (!this.isReload) {
      // 👉 Clear cookies only on close
      this.cookieService.delete('loginSubscriptionData', '/');
      localStorage.clear();
      sessionStorage.clear();
    }
    this.isReload = false; // reset
  }
}
